export default __webpack_public_path__ + "static/home-hero-image-4a1a952c423a09bdaedacdb14c45dc04.png";